import { __assign } from "tslib";
import { createHttpTestKit } from "./../http/test-kit";
import { createWasabiApi, } from ".";
import { createFakeDeleteResponder, createFakeGetResponder, createFakePostResponder, createFakePutResponder, } from "..";
export var createWasabiApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createWasabiApi(fakeHttp);
    var testKit = {
        whenCreateDashboard: function (dto) {
            return createFakePostResponder(fakeHttp, "/apps/wasabi/dashboards")(dto);
        },
        whenEditDashboard: function (dto) {
            return createFakePutResponder(fakeHttp, "/apps/wasabi/dashboards/" + (dto !== "*" && dto.dashboardId))(dto);
        },
        whenGetAll: function (dto) {
            if (dto === "*") {
                return createFakeGetResponder(fakeHttp, dto);
            }
            else {
                return createFakeGetResponder(fakeHttp, "/apps/wasabi/getAll?tenantId=" + dto.tenantId);
            }
        },
        whenDelete: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "https://" + (dto !== "*" && dto.defaultHost) + "/apps/wasabi/dashboards/" + (dto !== "*" && dto.dashboardId));
        },
        whenDuplicate: function (dto) {
            return createFakePostResponder(fakeHttp, "/apps/wasabi/dashboards/" + (dto !== "*" && dto.dashboardId) + "/duplicate")({
                tenantId: (dto !== "*" && dto.tenantId) || "",
                title: (dto !== "*" && dto.title) || "",
                description: (dto !== "*" && dto.description) || "",
                isDefault: (dto !== "*" && dto.isDefault),
            });
        },
        whenGetAllSchedules: function (dto) {
            if (dto === "*") {
                return createFakeGetResponder(fakeHttp, dto);
            }
            else {
                return createFakeGetResponder(fakeHttp, "/apps/wasabi/schedules?tenantId=" + dto.tenantId + "&userEmail=" + dto.userEmail);
            }
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map